import { Component } from '@angular/core';

@Component({
    selector: 'app-user-terms',
    templateUrl: './user-terms.component.html',
    styleUrl: './user-terms.component.scss',
    standalone: false
})
export class UserTermsComponent {

}
